


































import Vue from 'vue'
import { ValidationProvider } from 'vee-validate'
import '@/tools/vee-validate'
import Dropdown from '@/components/globals/basics/Dropdown.vue'
import Icon from '@/components/globals/Icon.vue'

export default Vue.extend({
  name: 'ProfileSelectWithValidation',
  components: {
    ValidationProvider,
    Dropdown,
    Icon,
  },
  props: {
    vid: {
      type: String as () => string,
      default: '',
    },
    rules: {
      type: String as () => string,
      default: '',
    },
    // must be included in props
    value: {
      //@ts-ignore
      type: null as () => any,
      default: '',
    },
    options: {
      type: Array as () => { value: string; text: string }[],
      default: () => [],
    },
  },
  data: () => ({
    innerValue: '',
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal)
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
})
